import { CommonScriptComponent } from './../common-script/common-script.component';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-digital-marketing-agency',
  templateUrl: './digital-marketing-agency.component.html',
  styleUrls: ['./digital-marketing-agency.component.css']
})
export class DigitalMarketingAgencyComponent implements OnInit {

  constructor(private commonScriptComponent:CommonScriptComponent) { }

  ngOnInit() {
    this.commonScriptComponent.onLoad();
  }

}



// WEBPACK FOOTER //
// D:/Projects/Veepal/Veepal.Com/Dev/src/app/digital-marketing-agency/digital-marketing-agency.component.ts